export const userType = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  SALES: "sales",
  CLIENT: "client",
};

export const access = {
  SURVEYS_WRITE: "surveys.write",
  SURVEYS_MONITOR: "surveys.monitor",
  SURVEYS_ANALYZE: "surveys.analyze",
  ACCOUNTS_MANAGE: "accounts.manage",
  ACCOUNTS_READ: "accounts.read",
};

export const roleKey = {
  CLIENT_EDIT: "client_edit",
  CLIENT_ANALYZE: "client_analyze",
  CLIENT_MONITOR: "client_monitor",
};

export const epistoUserTypes = [userType.SUPER_ADMIN, userType.ADMIN, userType.SALES];
